import styled from "@emotion/styled";
import { MergeWithOverwrite } from "src/common";
import { colors } from "src/theme";

const IconSpan = styled.span((props: { height: number; width: number }) => ({
  display: "inline-flex",
  height: props.height,
  width: props.width,
}));

export type CloseIconProps = MergeWithOverwrite<
  React.HtmlHTMLAttributes<HTMLSpanElement>,
  {
    width?: number;
    height?: number;
    color?: string;
  }
>;

export const CloseIcon: React.FC<CloseIconProps> = ({
  width = 16,
  height = 16,
  color = colors.primary,
  ...props
}) => (
  <IconSpan {...props} height={height} width={width}>
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M4.76732 12.6654L3.83398 11.732L7.56732 7.9987L3.83398 4.26536L4.76732 3.33203L8.50065 7.06536L12.234 3.33203L13.1673 4.26536L9.43398 7.9987L13.1673 11.732L12.234 12.6654L8.50065 8.93203L4.76732 12.6654Z"
        fill={color}
      />
    </svg>
  </IconSpan>
);
